import { IStore } from "~/state/store";
import { IProvider } from "~/util/providers/photo";
import { ICanonical } from "~/canonical";

export let store: IStore = null;
// tady bych tedy radeji videl jednotlive exportovane funkce kvuli typum a taky moznosti neimportovat vsechno
export let Provider: IProvider = null;
export let Canonical: ICanonical = null;
export let Notifications: any = null;

export function setGlobals(global) {
	store = global.store;
	Provider = global.Provider;
	Canonical = global.Canonical;
	Notifications = global.Notifications;
}
